import axios from 'axios';
import URLParse from 'url-parse';
import { getApiUrl } from './Env';

class AxiosAPI {
    url = '';

    setHeaders = () => {
        axios.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
        axios.defaults.headers.common['Init-Id'] = localStorage.getItem('init-id');
        axios.defaults.headers.common['Client-Time'] = new Date();
        axios.defaults.headers.common.Locale = localStorage.getItem('local');
        axios.defaults.headers.common.Authorization = localStorage.getItem('token');
        return this;
    };

    currentUserAuth = (authInfo) => {
        axios.defaults.headers.common.Authorization = authInfo?.token || '';

        return this;
    };

    setUrl = (url) => {
        this.url = url;
        return this;
    };

    setPath = (path, query = {}) => {
        const rUrl = `${getApiUrl()}/${path}`
            .split('/')
            .filter((item) => !!item)
            .join('/');

        const URL = new URLParse(rUrl, true);
        URL.query = { ...URL.query, ...query };
        this.url = URL.toString();

        return this;
    };

    getUrl = () => this.url;

    get = (options) => {
        this.setHeaders();

        return new Promise((resolve, reject) => {
            axios
                .get(this.url, options)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    };

    post = (params, options) => {
        this.setHeaders();

        return new Promise((resolve, reject) => {
            axios
                .post(this.url, params, options)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    };

    put = (params, options) => {
        this.setHeaders();
        return new Promise((resolve, reject) => {
            axios
                .put(this.url, params, options)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    };

    patch = (params, options) => {
        this.setHeaders();
        return new Promise((resolve, reject) => {
            axios
                .patch(this.url, params, options)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    };

    delete = (params, options) => {
        this.setHeaders();
        return new Promise((resolve, reject) => {
            axios
                .delete(this.url, params, options)
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    };
}

export default () => {
    const axiosApi = new AxiosAPI();

    return axiosApi;
};
